<div #editorContainer class="editor-container" [class.expanded]="expanded"></div>
